import { render, staticRenderFns } from "./performStep.vue?vue&type=template&id=22b903f5&scoped=true"
import script from "./performStep.vue?vue&type=script&lang=js"
export * from "./performStep.vue?vue&type=script&lang=js"
import style0 from "./performStep.vue?vue&type=style&index=0&id=22b903f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b903f5",
  null
  
)

export default component.exports